// Versao no endereco: sem ela o navegador segue mostrando o favicon antigo guardado
// depois de uma troca de marca.
const FAVICON_VERSION = 'atende2';

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png?v=${FAVICON_VERSION}`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png?v=${FAVICON_VERSION}`;
        favicon.href = oldFileName;
      });
    }
  });
};
